import { render } from "./Perizie.vue?vue&type=template&id=915a1908&scoped=true&ts=true"
import script from "./Perizie.vue?vue&type=script&lang=ts"
export * from "./Perizie.vue?vue&type=script&lang=ts"

import "./Perizie.vue?vue&type=style&index=0&id=915a1908&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_assitech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-915a1908"]])

export default __exports__